import React from 'react';
import { Textarea, TextareaProps } from '@rebass/forms';
import { Flex, Text } from 'rebass';

type GrowyTextAreaProps = Omit<TextareaProps, 'height' | 'value'> & {
  value?: string;
  height: number;
  focusedHeight: number;
  hasValueHeight?: number;
  maxCharacters?: number;
};

export const GrowyTextarea: React.FC<GrowyTextAreaProps> = ({
  height,
  focusedHeight,
  placeholder = 'Enter message',
  maxCharacters,
  hasValueHeight = height,
  ...props
}) => (
  <Flex
    flexGrow={0}
    flexShrink={0}
    justifyItems="stretch"
    flexDirection="column"
    sx={{ gap: 1, width: props.width ?? '100%' }}
  >
    <Textarea
      {...(props as any)}
      height={props.value ? hasValueHeight : height}
      onBlur={(e) => {
        if (!e.target.value) {
          e.target.style.height = `${props.value ? hasValueHeight : height}px`;
        }
        props.onBlur?.(e);
      }}
      onFocus={(e) => {
        e.target.style.height = `${focusedHeight}px`;
        props.onFocus?.(e);
      }}
      onChange={(e) => {
        let value = e.target.value ?? ('' as string);
        if (maxCharacters && value.length > maxCharacters) {
          e.target.value = value = value.substring(0, maxCharacters);
        }
        props.onChange?.(e);
      }}
      placeholder={placeholder}
      sx={{ width: '100%', flexGrow: 1, transition: 'height .3s', ...props.sx }}
    />
    {props.value && maxCharacters && props.value.length > maxCharacters / 2 && (
      <Text textAlign="right" variant="subheading" fontWeight="normal">
        {props.value.length} of {maxCharacters}
      </Text>
    )}
  </Flex>
);
